<template>
  <div class="view-container">
    <!-- Show spash screen -->
    <div v-if="showLoader">
      <app-loader :fadeoutLoader="fadeoutLoader"></app-loader>
    </div>
    <div v-if="fadeoutLoader"></div>
    <div class="tab-container">
      <div class="tab-message">
        <h1>Success</h1>
        <p>
          <span v-if="tableNo" style="">Table No {{ tableNo }}</span
          ><span v-else>Bar Tab</span>
          <br />
          has successfully been <span v-if="tableNo" style="">reserved</span
          ><span v-else>opened</span>.
          <br />
          To continue:
        </p>
      </div>
      <div>
        <router-link
          to="Login"
          class="btn btn-primary"
          :style="'background-color:' + accentColor"
          >Login</router-link
        >
        <router-link to="Register" class="btn btn-success"
          >Register</router-link
        >
      </div>
      <div>
        <router-link
          to="Menu"
          class="btn btn-primary"
          :style="'background-color:' + accentColor"
          >Place an order</router-link
        >
      </div>
    </div>
  </div>
</template>
<!-- Scripts -->
<script>
import loaderPartial from "@/components/LoaderPartial.vue";
import { splashScreen } from "@/mixins/splashScreen";
import { view } from "./Tab.vue.js";

export default {
  name: "Tab",
  components: {
    "app-loader": loaderPartial,
  },
  mixins: [splashScreen, view],
  data() {
    return {
      franchise: this.$route.query.frchs,
      branchID: this.$route.query.brch,
      tableNo: this.$route.query.tbl,
    };
  },
  computed: {
    accentColor: function () {
      return this.$franchiseAccentColor;
    },
  },
  created() {
    var _self = this;

    _self.$franchiseName = _self.franchise;
    _self.$branchID = _self.branchID;
    _self.$isTab = _self.tableNo == undefined ? true : null;
    _self.$tableNo = _self.tableNo;

    if (!_self.$franchiseName || !_self.$branchID) {
      _self.clearComputed;
      _self.$router.push('Franchise');
    }

    _self.showSplashScreen();

    var franchiseData = {
      FranchiseID: 0,
      FranchiseName: this.franchise,
    };
    _self.$ooApi.orders.franchises.get
      .v1(franchiseData)
      .then(function (result) {
        _self.$franchiseID = result.data.id;
        _self.$franchiseName = result.data.name;
        _self.$franchiseUrlFriendlyOrderName = result.data.urlFriendlyOrderName;
        _self.$franchiseLogoUrl = result.data.franchiseLogoURL;
        _self.$franchiseBannerUrl = result.data.bannerImageURL;
        _self.$franchiseAccentColor = result.data.accentColor;
        _self.$franchiseAccentColor = result.data.accentColor;
        _self.$lastSessionDate = new Date();

        _self.initOoApi(_self.$franchiseID);
        _self.initPayApi(_self.$franchiseID);
        _self.hideSplashScreen();
      });
  },
};
</script>
<style scoped>
@import "./Tab.vue.css";
</style>
